/**
 * StatusTag — pill colorido para o estágio do funil de um contato.
 * Extraído de Chat.tsx para reuso entre ContactListItem e outros locais.
 */

import React from 'react';
import {
  MessageSquare,
  Target,
  UserX,
  Calendar,
  HeartHandshake,
  CheckCircle2,
  XCircle,
  DollarSign,
} from 'lucide-react';

export type FunnelStage =
  | 'contato'
  | 'lead'
  | 'agendado'
  | 'compareceu'
  | 'faltou'
  | 'venda'
  | 'paciente'
  | 'perdido';

interface StatusTagProps {
  status: FunnelStage | string;
  className?: string;
}

const config: Record<FunnelStage, { bgColor: string; textColor: string; Icon: any; label: string }> = {
  perdido: { bgColor: 'bg-gray-200', textColor: 'text-gray-700', Icon: UserX, label: 'Perdido' },
  contato: { bgColor: 'bg-gray-100', textColor: 'text-gray-700', Icon: MessageSquare, label: 'Contato' },
  lead: { bgColor: 'bg-sminy-primary/10', textColor: 'text-sminy-primary', Icon: Target, label: 'Lead' },
  agendado: { bgColor: 'bg-yellow-100', textColor: 'text-yellow-700', Icon: Calendar, label: 'Agendado' },
  paciente: { bgColor: 'bg-purple-100', textColor: 'text-purple-700', Icon: HeartHandshake, label: 'Paciente' },
  compareceu: { bgColor: 'bg-emerald-100', textColor: 'text-emerald-700', Icon: CheckCircle2, label: 'Compareceu' },
  faltou: { bgColor: 'bg-rose-100', textColor: 'text-rose-700', Icon: XCircle, label: 'Faltou' },
  venda: { bgColor: 'bg-emerald-100', textColor: 'text-emerald-700', Icon: DollarSign, label: 'Venda' },
};

const StatusTag: React.FC<StatusTagProps> = ({ status, className = '' }) => {
  const cfg = config[status as FunnelStage];
  if (!cfg) return null;

  return (
    <span className={`${cfg.bgColor} ${cfg.textColor} rounded-full px-2 py-0.5 text-xs font-medium flex items-center ${className}`}>
      <cfg.Icon className="w-3 h-3 mr-1 flex-shrink-0" />
      <span className="truncate">{cfg.label}</span>
    </span>
  );
};

export default StatusTag;
